import React from 'react';
import Card from '../Card';
import DraggableGroup from '../DraggableGroup';
import {ICard, ICardsRenderInfo, IPile} from '../../redux/types';
import {DraggableCardNumber, MoveTo} from '../Laid/Pile/types';
import {ShadowProps} from "../DraggableGroup/Shadow";

type IProps = {
  cards: IPile,
  cardParameters: ICardsRenderInfo,
  onDragEnd(node: any, x: number, y: number, cardIndex: number): void,
  onDragStart(node: object, draggableCardNumber: DraggableCardNumber): void,
  draggable: boolean,
  draggableCardNumber: DraggableCardNumber,
  isHintMove: boolean,
  onDblClick: (node: any, draggableCardNumber: DraggableCardNumber) => void,
  moveTo: MoveTo,
}

function RecursiveGroup(props: IProps) {
  const {
    cards,
    cardParameters,
    onDragEnd,
    onDragStart,
    draggableCardNumber,
    moveTo,
    draggable,
    isHintMove,
    onDblClick,
  } = props;

  function renderGroup(index: number) {

    const card: ICard = cards[index];
    const { width, height, offset, normalShadow, corner } = cardParameters;
    const groupSize = cards.length;

    const isFirst: boolean = Boolean(index === 0);
    const isDraggingCard: boolean = Boolean(draggableCardNumber === index);
    const o: number = isDraggingCard ? 0 : (draggableCardNumber ? (groupSize - draggableCardNumber) : 0);
    const shadowHeight: number = height + ( (groupSize - index - 1 - o) * offset );
    const shadowSize: number = isHintMove ? normalShadow : isDraggingCard ? normalShadow * 2 : normalShadow;
    const y: number = index === 0 ? 0 : offset;

    const shadowProps: ShadowProps = {
      isVisible: Boolean(isFirst || isDraggingCard),
      shadowHeight,
      shadowSize,
      shadowBlur: normalShadow,
      width,
      height,
      corner,
    };

    return (
      <DraggableGroup
        y={y}
        onDblClick={(node: any) => {
          if (card.isSingleCard) onDblClick(node, index);
        }}
        onDragEnd={(event: any) => {
          onDragEnd(event.target, 0, y, index);
        }}
        onDragStart={(event: any) => {
          onDragStart(event.target, index);
        }}
        draggable={Boolean(draggable && card.draggable)}
        card={card}
        moveTo={(card: any, x: number, y: number, cardX: number) => moveTo(card, x, y, cardX, index)}
        shadowProps={shadowProps}
      >
        <Card card={card} />
        {index === cards.length - 1 ? null : renderGroup(index + 1)}
      </DraggableGroup>
    )
  }

  return renderGroup(0);
}

export default RecursiveGroup;
